"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function setImageData(imageData, targetColor, newColorSelected, newColorUnselected, tolerance) {
  var currentPixelColor = {
    r: null,
    g: null,
    b: null
  };
  var pixels = imageData.data;
  var isMask = (Math.abs(newColorSelected.r - newColorUnselected.r) + Math.abs(newColorSelected.g - newColorUnselected.g) + Math.abs(newColorSelected.b - newColorUnselected.b)) / 3 === 255; // loop through imageData

  for (var i = 0, n = imageData.data.length; i < n; i += 4) {
    currentPixelColor.r = imageData.data[i];
    currentPixelColor.g = imageData.data[i + 1];
    currentPixelColor.b = imageData.data[i + 2];
    var diff = (Math.abs(currentPixelColor.r - targetColor.r) + Math.abs(currentPixelColor.g - targetColor.g) + Math.abs(currentPixelColor.b - targetColor.b)) / 3;

    if (diff > tolerance) {
      pixels[i] = newColorUnselected.r;
      pixels[i + 1] = newColorUnselected.g;
      pixels[i + 2] = newColorUnselected.b;
      pixels[i + 3] = newColorSelected.a === 0 && isMask ? diff : newColorUnselected.a;
    } else {
      pixels[i] = newColorSelected.r;
      pixels[i + 1] = newColorSelected.g;
      pixels[i + 2] = newColorSelected.b;
      pixels[i + 3] = newColorSelected.a;
    }
  }
} // the following is from https://stackoverflow.com/a/5624139/2630316


function hexToRgb(hex) {
  var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function (m, r, g, b) {
    return r + r + g + g + b + b;
  });
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
}

function loadImage(url) {
  return new Promise(function (resolve, reject) {
    var img = new Image();
    img.src = url;
    img.addEventListener('load', function () {
      return resolve(img);
    });
    img.addEventListener('error', function () {
      reject(new Error("Failed to load image ".concat(url)));
    });
  });
}

var CanvasMagicWand = {
  knockoutColor: function () {
    var _knockoutColor = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var config,
          _config$img,
          img,
          _config$src,
          src,
          _config$targetColor,
          targetColor,
          _config$replacementCo,
          replacementColor,
          _config$tolerance,
          tolerance,
          _config$edgeBlur,
          edgeBlur,
          _config$edgeBrightnes,
          edgeBrightness,
          _config$edgeContrast,
          edgeContrast,
          _config$debugMode,
          debugMode,
          w,
          h,
          newColorSelected,
          newColorUnselected,
          canvas1,
          ctx,
          imageData,
          canvas2,
          canvas3,
          canvasDisplay,
          canvasReplacementColor,
          _args = arguments;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              config = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              _config$img = config.img, img = _config$img === void 0 ? null : _config$img;
              _config$src = config.src, src = _config$src === void 0 ? null : _config$src, _config$targetColor = config.targetColor, targetColor = _config$targetColor === void 0 ? '#fff' : _config$targetColor, _config$replacementCo = config.replacementColor, replacementColor = _config$replacementCo === void 0 ? '#ffffff00' : _config$replacementCo, _config$tolerance = config.tolerance, tolerance = _config$tolerance === void 0 ? 10 : _config$tolerance, _config$edgeBlur = config.edgeBlur, edgeBlur = _config$edgeBlur === void 0 ? 4 : _config$edgeBlur, _config$edgeBrightnes = config.edgeBrightness, edgeBrightness = _config$edgeBrightnes === void 0 ? 2 : _config$edgeBrightnes, _config$edgeContrast = config.edgeContrast, edgeContrast = _config$edgeContrast === void 0 ? 6 : _config$edgeContrast, _config$debugMode = config.debugMode, debugMode = _config$debugMode === void 0 ? false : _config$debugMode;

              if (!(src !== null || img !== null && img.naturalWidth === 0)) {
                _context.next = 17;
                break;
              }

              if (!(img === null && typeof src !== 'string')) {
                _context.next = 6;
                break;
              }

              throw Error('src must be a string');

            case 6:
              _context.prev = 6;
              _context.next = 9;
              return loadImage(src || img.src);

            case 9:
              img = _context.sent;
              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](6);
              console.error(_context.t0);

            case 15:
              _context.next = 19;
              break;

            case 17:
              if (img instanceof Image) {
                _context.next = 19;
                break;
              }

              throw Error('must provide a HTMLImageElement or a String representing the image\'s src attribute');

            case 19:
              w = img.naturalWidth;
              h = img.naturalHeight;
              newColorSelected = {
                r: 255,
                g: 255,
                b: 255,
                a: 255
              };
              newColorUnselected = {
                r: 0,
                g: 0,
                b: 0,
                a: 255
              };
              canvas1 = document.createElement('canvas');
              canvas1.width = w;
              canvas1.height = h;
              ctx = canvas1.getContext('2d');
              ctx.drawImage(img, 0, 0);
              imageData = ctx.getImageData(0, 0, w, h);
              setImageData(imageData, hexToRgb(targetColor), newColorSelected, newColorUnselected, tolerance);
              ctx.putImageData(imageData, 0, 0);
              canvas2 = document.createElement('canvas');
              canvas2.width = canvas1.width;
              canvas2.height = canvas1.height;
              ctx = canvas2.getContext('2d');
              ctx.filter = "blur( ".concat(edgeBlur, "px ) brightness( ").concat(edgeBrightness, " ) contrast( ").concat(edgeContrast, " )");
              ctx.drawImage(canvas1, 0, 0);
              canvas3 = document.createElement('canvas');
              canvas3.width = canvas1.width;
              canvas3.height = canvas1.height;
              ctx = canvas3.getContext('2d');
              ctx.drawImage(canvas2, 0, 0);
              imageData = ctx.getImageData(0, 0, w, h);
              setImageData(imageData, {
                r: 255,
                g: 255,
                b: 255
              }, _objectSpread({}, newColorSelected, {
                a: 0
              }), newColorUnselected, 10);
              ctx.putImageData(imageData, 0, 0);
              canvasDisplay = document.createElement('canvas');
              canvasDisplay.width = w;
              canvasDisplay.height = h;
              ctx = canvasDisplay.getContext('2d');
              ctx.drawImage(canvas3, 0, 0);
              ctx.globalCompositeOperation = 'source-in';
              ctx.drawImage(img, 0, 0);
              canvasReplacementColor = document.createElement('canvas');
              canvasReplacementColor.width = w;
              canvasReplacementColor.height = h;
              ctx = canvasReplacementColor.getContext('2d');
              ctx.fillStyle = debugMode ? '#fff' : replacementColor;
              ctx.fillRect(0, 0, w, h);
              ctx.drawImage(debugMode ? canvas2 : canvasDisplay, 0, 0);
              img = new Image();
              img.src = canvasReplacementColor.toDataURL();
              return _context.abrupt("return", img);

            case 62:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[6, 12]]);
    }));

    function knockoutColor() {
      return _knockoutColor.apply(this, arguments);
    }

    return knockoutColor;
  }()
};
var _default = CanvasMagicWand;
exports.default = _default;
